import { Component, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  customerServicePhone: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container">
          <div className="alert alert-danger" role="alert">
            <h4>Something went wrong</h4>
            <p>We're sorry, an unexpected error occurred. Please refresh the page to try again.</p>
            {this.props.customerServicePhone && (
              <p>
                If the problem persists, please contact Customer Service at{' '}
                <strong>{this.props.customerServicePhone}</strong>.
              </p>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
